var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicianSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66283 19.8638C4.73033 18.828 1.83366 15.253 1.83366 10.9997C1.83366 5.93967 5.90366 1.83301 11.0003 1.83301C17.1145 1.83301 20.167 6.92967 20.167 6.92967M20.167 6.92967V2.74967M20.167 6.92967H18.3245H16.097",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 20.167C14.1978 20.167 17.0149 18.5266 18.6553 16.042",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C12.3807 11 13.5 9.88071 13.5 8.5C13.5 7.11929 12.3807 6 11 6C9.61929 6 8.5 7.11929 8.5 8.5C8.5 9.88071 9.61929 11 11 11Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2951 16C15.2951 14.065 13.3701 12.5 11.0001 12.5C8.63008 12.5 6.70508 14.065 6.70508 16",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicianSwap);
export default __webpack_public_path__ + "static/media/technician-swap.6517091bd7bb8c8993466b085ee47632.svg";
export { ForwardRef as ReactComponent };